import { Alert } from "@instructure/ui-alerts";
import { useTranslation } from "react-i18next";

const PageNotFound = () => {
  const { t } = useTranslation();
  return <Alert variant="error">{t("errorPage.notExistent")}</Alert>;
};

export default PageNotFound;
